<template>
  <div class="view pa24">
    <el-page-header @back="goBack" content="" style="margin-bottom: 20px">
    </el-page-header>
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="query.handle" class="mb10" style="width: 240px" placeholder="请输入标识码" clearable />
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button class="ml10 mb10" type="primary" @click="printAll">批量打印</el-button>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="name" align="center" label="名称" />
      <el-table-column prop="handle" align="center" label="标识码" />
      <el-table-column prop="handle" align="center" label="指定产品" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div v-for="(item,index) in scope.row.classNames" :key="index">{{item}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="handle" align="center" label="二维码">
        <template slot-scope="scope">
          <vue-qr :id="`codeImage${scope.row.handle}`" :size="50" :margin="0" :auto-color="true" :dot-scale="1"
            :text="`${codeUrl}?h=${scope.row.handle}`" />
        </template>
      </el-table-column>
      <el-table-column prop="handle" align="center" label="图片">
        <template slot-scope="scope">
          <el-image v-if="scope.row.img" style="width: 80px; height: 80px" :src="ossUrl + scope.row.img" fit="fit"
            :preview-src-list="[ossUrl + scope.row.img]"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" align="center" label="备注" :show-overflow-tooltip="true" />
      <el-table-column prop="num" align="center" label="数量" v-if="codeType != 0">
        <template slot-scope="scope">
          <el-button type="text" @click="codeDetail(scope.row)">{{scope.row.num}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="num" align="center" label="重量(t)" v-else>
        <template slot-scope="scope">
          <el-button type="text" @click="codeDetail(scope.row)">{{(scope.row.weight / 1000).toFixed(4)}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="wareStatus" align="center" label="状态">
        <template slot-scope="scope">
          {{getStatus(scope.row.wareStatus)}}
        </template>
      </el-table-column>
      <el-table-column prop="warehouseName" align="center" label="位置">
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="创建时间" />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="printBtn(scope.row)">打印</el-button>
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: red" @click="delCode(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>
    <el-dialog title="容器码详情" :visible.sync="dialogTableVisible" modal-append-to-body append-to-body>
      <el-table :data="gridData">
        <el-table-column property="className" label="类别" align="center">
          <template slot-scope="scope">
            {{scope.row.className}}
            <span v-if="scope.row.specName">({{scope.row.specName}})</span>
          </template>
        </el-table-column>
        <el-table-column property="inventCode" label="存货编码" align="center"></el-table-column>
        <el-table-column property="partNumber" label="件号" align="center"></el-table-column>
        <el-table-column property="num" label="数量" align="center" v-if="codeType != 0"></el-table-column>
        <el-table-column property="weight" label="重量(t)" align="center" v-else></el-table-column>
      </el-table>
    </el-dialog>

    <!--打印-->
    <CodePrint ref="codePrint"></CodePrint>
    <StoreCodeEditDialog ref="storeCodeEditDialog" @getList="getList"></StoreCodeEditDialog>
  </div>
</template>
<script>
  import { selectCodeList, selectCodeDetailList, selectPrintCode } from '@/api/storeCode.js'
  import VueQr from 'vue-qr'
  import CodePrint from "./codePrint.vue";
  import { selectAllPrintList } from '@/api/storeCodePrint.js'
  import StoreCodeEditDialog from "./storeCodeEditDialog.vue";
  import { codeUrl } from '@/utils/constant'
  import { deleteCode } from '@/api/storeCode.js'
  export default {
    name: 'codeDetail',
    components: {
      VueQr, CodePrint, StoreCodeEditDialog
    },
    directives: {

    },
    props: {

    },
    data() {
      return {
        codeUrl: codeUrl,
        ossUrl: this.$store.state.ossUrl,
        name: null,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        batchId: '',
        query: {
          handle: ''
        },
        dialogTableVisible: false,
        gridData: [],
        dialogPrintVisible: false,
        printList: [],
        printId: '',
        printDataList: [],
        paperWidth: 70,
        paperHeight: 30,
        timer: '',
        codeType: this.$route.query.codeType
      };
    },
    created() {
      this.batchId = this.$route.query.id
      this.getList()
    },
    methods: {
      getStatus(status) {
        if (0 == status) {
          return '未入库'
        } else if (1 == status) {
          return '已入库'
        } else if (2 == status) {
          return '已出库'
        } else {
          return '未知'
        }
      },
      getCustomer() {
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddCode(id) {
        this.$router.push({ path: '/store/addCode' })
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          batchId: this.batchId
        }
        let param = { ...params, ...this.query }
        selectCodeList(param).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      codeDetail(row) {
        selectCodeDetailList({ codeId: row.id }).then(res => {
          this.gridData = res.data
          this.dialogTableVisible = true
        })
      },
      goBack() {
        this.$router.push({ path: '/store/code' })
      },
      printBtn(data) {
        this.$refs.codePrint.init('', data.id, 'single', '')
      },
      printAll() {
        this.$refs.codePrint.init(this.batchId, '', 'all', '')
      },
      edit(row) {
        this.$refs.storeCodeEditDialog.getAllClass(row.codeType == 0 ? 1 : 0)
        this.$refs.storeCodeEditDialog.getClassList(row.id)
        this.$refs.storeCodeEditDialog.init(row)
      },
      delCode(row) {
        let params = {
          codeId: row.id
        }
        this.$confirm('此操作将永久删除该容器码, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteCode(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {

        })
      },
    },
  }
</script>
<style scoped lang="scss">

</style>